import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Box, Flex } from 'reflexbox'
import { Select } from '@blueprintjs/select'
import {
    Button,
    Classes,
    Dialog,
    InputGroup,
    Label,
    MenuItem,
    Tag,
    TextArea,
} from '@blueprintjs/core'
import { DateInput, TimePrecision } from '@blueprintjs/datetime'

import { getAction } from 'src/store/modules/runbooks/actions'
import { TIMESTAMP_FORMAT } from 'src/utils/reducer'

class AddActivityDialog extends React.Component {
    state = {
        id: null,
        priority: this.props.priorityChoices[0],
        status: this.props.statusChoices[0],
        date: new Date(),
        due: new Date(),
        closed: new Date(),
        company: '',
        source: '',
        owner: '',
        description: '',
        comments: '',
    }

    componentDidMount() {
        let state = {}
        Object.keys(this.state).forEach((field) => {
            if (this.props[field] !== undefined) {
                state[field] = this.props[field]
            }
        })

        if (state.hasOwnProperty('priority')) {
            state.priority = this.props.priorityChoices.find(
                (choice) => choice[0] === state.priority
            )
        }
        if (state.hasOwnProperty('status')) {
            state.status = this.props.statusChoices.find(
                (choice) => choice[0] === state.status
            )
        }
        if (state.hasOwnProperty('due')) {
            state.due = moment(state.due).toDate()
        }
        if (state.hasOwnProperty('date')) {
            state.date = moment(state.date).toDate()
        }
        if (state.hasOwnProperty('closed')) {
            state.closed = moment(state.closed).toDate()
        }

        if (Object.keys(state).length) {
            this.setState(state)
        }
    }

    handleCreateClick = () => {
        this.props.handleConfirm({
            id: this.state.id,
            owner: this.state.owner,
            priority: this.state.priority[0],
            status: this.state.status[0],
            date: this.state.date,
            due: this.state.due,
            closed: this.state.closed,
            company: this.state.company,
            source: this.state.source,
            description: this.state.description,
            comments: this.state.comments,
            actionUid: this.props.fromAction,
        })
        this.props.handleClose()
    }

    itemRenderer = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item[0]}
                onClick={handleClick}
                text={item[1]}
            />
        )
    }

    render() {
        const { handleClose, action } = this.props
        return (
            <Dialog
                onClose={handleClose}
                title="Log an activity"
                isOpen={true}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    {action ? (
                        <React.Fragment>
                            <div style={{ marginBottom: 5 }}>Action</div>
                            <Tag style={{ marginRight: 5 }}>{action.uid}</Tag>
                            <Tag style={{ marginBottom: 15 }} intent="danger">
                                {action.name}
                            </Tag>
                        </React.Fragment>
                    ) : null}

                    <Flex>
                        <Box w={1 / 2}>
                            <Label style={{ padding: '0 5px 0 0' }}>
                                Status
                                <Select
                                    items={this.props.statusChoices}
                                    filterable={false}
                                    itemRenderer={this.itemRenderer}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    onItemSelect={(value) =>
                                        this.setState({ status: value })
                                    }
                                >
                                    <Button
                                        className="full-width"
                                        text={
                                            this.state.status
                                                ? this.state.status[1]
                                                : 'Select status...'
                                        }
                                        rightIcon="double-caret-vertical"
                                        alignText="left"
                                    />
                                </Select>
                            </Label>
                        </Box>
                        <Box w={1 / 2}>
                            <Label style={{ padding: '0 5px' }}>
                                Priority
                                <Select
                                    className="full-width"
                                    items={this.props.priorityChoices}
                                    filterable={false}
                                    itemRenderer={this.itemRenderer}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    onItemSelect={(value) =>
                                        this.setState({ priority: value })
                                    }
                                >
                                    <Button
                                        className="full-width"
                                        text={
                                            this.state.priority
                                                ? this.state.priority[1]
                                                : 'Select priority...'
                                        }
                                        rightIcon="double-caret-vertical"
                                        alignText="left"
                                    />
                                </Select>
                            </Label>
                        </Box>
                    </Flex>
                    <Label>
                        Date
                        <DateInput
                            showActionsBar={true}
                            timePrecision={TimePrecision.MINUTE}
                            formatDate={(date) =>
                                moment(date).format(TIMESTAMP_FORMAT)
                            }
                            parseDate={(str) =>
                                moment(str, TIMESTAMP_FORMAT).toDate()
                            }
                            placeholder={TIMESTAMP_FORMAT}
                            onChange={(date) => {
                                this.setState({ date: date })
                            }}
                            value={moment(
                                this.state.date,
                                TIMESTAMP_FORMAT
                            ).toDate()}
                        />
                    </Label>
                    <Label>
                        Closed
                        <DateInput
                            showActionsBar={true}
                            timePrecision={TimePrecision.MINUTE}
                            formatDate={(date) =>
                                moment(date).format(TIMESTAMP_FORMAT)
                            }
                            parseDate={(str) =>
                                moment(str, TIMESTAMP_FORMAT).toDate()
                            }
                            placeholder={TIMESTAMP_FORMAT}
                            onChange={(date) => {
                                this.setState({ closed: date })
                            }}
                            value={moment(
                                this.state.closed,
                                TIMESTAMP_FORMAT
                            ).toDate()}
                        />
                    </Label>
                    <Label>
                        Due
                        <DateInput
                            showActionsBar={true}
                            timePrecision={TimePrecision.MINUTE}
                            formatDate={(date) =>
                                moment(date).format(TIMESTAMP_FORMAT)
                            }
                            parseDate={(str) =>
                                moment(str, TIMESTAMP_FORMAT).toDate()
                            }
                            placeholder={TIMESTAMP_FORMAT}
                            onChange={(date) => {
                                this.setState({ due: date })
                            }}
                            value={moment(
                                this.state.due,
                                TIMESTAMP_FORMAT
                            ).toDate()}
                        />
                    </Label>
                    <Label>
                        Owner
                        <InputGroup
                            value={this.state.owner}
                            maxLength={128}
                            onChange={(e) =>
                                this.setState({ owner: e.target.value })
                            }
                        />
                    </Label>
                    <Label>
                        Company
                        <InputGroup
                            value={this.state.company}
                            maxLength={128}
                            onChange={(e) =>
                                this.setState({ company: e.target.value })
                            }
                        />
                    </Label>
                    <Label>
                        Source
                        <InputGroup
                            value={this.state.source}
                            maxLength={128}
                            onChange={(e) =>
                                this.setState({ source: e.target.value })
                            }
                        />
                    </Label>
                    <Label>
                        Description
                        <TextArea
                            fill={true}
                            onChange={(e) =>
                                this.setState({ description: e.target.value })
                            }
                            value={this.state.description}
                            maxLength={128}
                        />
                    </Label>
                    <Label>
                        Comments
                        <TextArea
                            fill={true}
                            onChange={(e) =>
                                this.setState({ comments: e.target.value })
                            }
                            value={this.state.comments}
                            maxLength={128}
                        />
                    </Label>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            large
                            disabled={!this.isStateValid()}
                            onClick={this.handleCreateClick}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }

    isStateValid = () => {
        return !(
            !this.state.owner ||
            !this.state.description ||
            !this.state.closed ||
            !this.state.due ||
            !this.state.priority ||
            !this.state.status ||
            !this.state.company ||
            !this.state.source ||
            !this.state.comments ||
            !this.state.date
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        // TODO: refactor this once actions are asynchronously fetched.
        action: ownProps.fromAction
            ? getAction(
                  state,
                  state.ui.runbook.activeRunbook,
                  ownProps.fromAction
              )
            : null,
        priorityChoices: state.app.activityLogPriorities,
        statusChoices: state.app.activityLogStatuses,
    }
}

export default connect(mapStateToProps)(AddActivityDialog)
